"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIO_MIXING_DUAL_MONO_MODE = void 0;
var AUDIO_MIXING_DUAL_MONO_MODE;
(function (AUDIO_MIXING_DUAL_MONO_MODE) {
    AUDIO_MIXING_DUAL_MONO_MODE[AUDIO_MIXING_DUAL_MONO_MODE["AUDIO_MIXING_DUAL_MONO_AUTO"] = 0] = "AUDIO_MIXING_DUAL_MONO_AUTO";
    AUDIO_MIXING_DUAL_MONO_MODE[AUDIO_MIXING_DUAL_MONO_MODE["AUDIO_MIXING_DUAL_MONO_L"] = 1] = "AUDIO_MIXING_DUAL_MONO_L";
    AUDIO_MIXING_DUAL_MONO_MODE[AUDIO_MIXING_DUAL_MONO_MODE["AUDIO_MIXING_DUAL_MONO_R"] = 2] = "AUDIO_MIXING_DUAL_MONO_R";
    AUDIO_MIXING_DUAL_MONO_MODE[AUDIO_MIXING_DUAL_MONO_MODE["AUDIO_MIXING_DUAL_MONO_MIX"] = 3] = "AUDIO_MIXING_DUAL_MONO_MIX";
})(AUDIO_MIXING_DUAL_MONO_MODE || (exports.AUDIO_MIXING_DUAL_MONO_MODE = AUDIO_MIXING_DUAL_MONO_MODE = {}));
